import { ratingmodelState, Feedback } from "./models";

export async function ratingApi(options: ratingmodelState, abortSignal: AbortSignal): Promise<Response> {
    const response = await fetch("/Ratings", {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            rating: options
        }),
        signal: abortSignal
    });
    // console.log("RatingResponse");
    // console.log(response);
    return response;
}

export async function encuestaApi(data: {}): Promise<Response> {
    const response = await fetch("/encuesta", {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            encuesta: data
        })
    });
    return response;
}

export async function encuestaVariableGlobal() {
    const response = await fetch("/encuesta_global", { method: "GET" });
    const data = await response.json();
    return data.habilitada;
}

export async function encuestaRealizada(cedula: any) {
    try {
        const response = await fetch(`/encuesta_realizada?cedula=${cedula}`, {
            method: "GET"
        });
        const data = await response.json();
        return data.encuesta_realizada;
    } catch (error) {
        console.error("Error al obtener la información de encuesta realizada:", error);
        return false; // Devolver un valor por defecto en caso de error
    }
}

export async function createFeedback(options: Feedback): Promise<Response> {
    const response = await fetch("http://127.0.0.1:5000/create_feedback", {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            user_id: options.user_id,
            type: options.type,
            comment: options.comment,
            message_id: options.message_id
        })
    });
    // console.log("RatingResponse");
    // console.log(response);
    return response;
}